import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@ntuctech/devex-tangram/Box';

const PageFooterSC = styled(Box)`
  width: 100%;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: inset 0px 0px 0px 1px #eaeaea;
  background-color: #ffffff;
  margin-top: 0.5rem;
  text-align: center;

  @media (max-width: ${(props) => `${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px`}) {
    padding: 1.5rem 1rem;
  }
`;

function PageFooter({ children }) {
  return <PageFooterSC mt={3}>{children}</PageFooterSC>;
}

PageFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageFooter;
